import { render } from "./MessageFlags.vue.js?vue&type=template&id=f1a4b836!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFlags.vue?vue&type=template&id=f1a4b836"
import script from "./MessageFlags.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFlags.vue?vue&type=script&lang=js"
export * from "./MessageFlags.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFlags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/conversations/components/message/MessageFlags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1a4b836"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1a4b836', __exports__)) {
    api.reload('f1a4b836', __exports__)
  }
  
  module.hot.accept("./MessageFlags.vue.js?vue&type=template&id=f1a4b836!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFlags.vue?vue&type=template&id=f1a4b836", () => {
    api.rerender('f1a4b836', render)
  })

}


export default __exports__